import { render } from "./vCenter_Text_Box.vue?vue&type=template&id=0ff2757a&scoped=true"
import script from "./vCenter_Text_Box.vue?vue&type=script&lang=js"
export * from "./vCenter_Text_Box.vue?vue&type=script&lang=js"

import "./vCenter_Text_Box.vue?vue&type=style&index=0&id=0ff2757a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff2757a"]])

export default __exports__